// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__9xqSM","footer":"ModalFilter_footer__2oOfY"};